/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_file_doc': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M-2-2h24v24H-2z"/><path pid="1" d="M0 0h20v20H0V0zm10 10.074c.066 0 .083.031.15.094l2.543 4.785c.033.015.083.047.116.047s.083-.032.116-.047C13.972 12.032 14.97 9.079 16 6.158c0-.095-.066-.158-.166-.158h-1.33c-.1 0-.116.047-.183.158l-1.811 5.274-2.344-4.895c-.066-.08-.116-.11-.166-.11s-.1.03-.166.11L7.49 11.4 5.68 6.158C5.612 6.048 5.596 6 5.496 6h-1.33c-.1 0-.166.063-.166.158 1.03 2.92 2.028 5.874 3.075 8.795.033.015.083.047.116.047s.083-.032.116-.047l2.543-4.785c.067-.063.084-.094.15-.094z" _fill="#2B5797"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_file_doc.js